/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Master_Detail_BackInputs */

const cs_settings_master_detail_back = /** @type {(inputs: Settings_Master_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na seznam`)
};

const en_settings_master_detail_back = /** @type {(inputs: Settings_Master_Detail_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to list`)
};

/**
* | output |
* | --- |
* | "Back to list" |
*
* @param {Settings_Master_Detail_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_master_detail_back = /** @type {((inputs?: Settings_Master_Detail_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Master_Detail_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_master_detail_back(inputs)
	return cs_settings_master_detail_back(inputs)
});